
import React from 'react';
import { useEditor } from '../contexts/EditorContext';
import { Language } from '../types';
import { getNestedValue } from '../utils/objectHelpers';

interface EditableTextProps {
  path: string; // e.g., "hero.title"
  lang: Language;
  className?: string;
  multiline?: boolean;
}

export const EditableText: React.FC<EditableTextProps> = ({ path, lang, className = "", multiline = false }) => {
  const { isEditMode, translations, updateTranslation } = useEditor();
  
  // 1. 获取目标语言的值
  const targetValue = getNestedValue(translations[lang], path);
  // 2. 获取英文作为兜底值（英文是核心源，保证有值）
  const englishFallback = getNestedValue(translations[Language.EN], path);
  
  // 核心逻辑：如果当前语言内容为空（包括未定义、空对象或空字符串），则强制显示英文
  const value = (targetValue !== undefined && targetValue !== null && String(targetValue).trim() !== "") 
    ? targetValue 
    : (englishFallback || "");

  if (isEditMode) {
    const inputClasses = `bg-primary-500/20 border-2 border-dashed border-primary-400/60 rounded px-3 py-1.5 w-full text-inherit placeholder-current/30 focus:outline-none focus:border-primary-400 focus:bg-primary-500/30 transition-all backdrop-blur-sm ${className}`;
    
    return (
      <div className="w-full inline-block min-w-[20px]">
        {multiline ? (
          <textarea 
            value={targetValue || ""} // 编辑时显示真实值，允许用户输入
            onChange={(e) => updateTranslation(lang, path, e.target.value)}
            className={inputClasses}
            rows={3}
            dir="auto"
            placeholder={`[EN]: ${englishFallback}`}
          />
        ) : (
          <input 
            type="text"
            value={targetValue || ""}
            onChange={(e) => updateTranslation(lang, path, e.target.value)}
            className={inputClasses}
            dir="auto"
            placeholder={`[EN]: ${englishFallback}`}
          />
        )}
      </div>
    );
  }

  return <span className={className}>{value}</span>;
};
